import entityBase from 'entityBase';
import * as ko from 'knockout';
import { place } from 'organized';

export class person_place extends entityBase {
    place: KnockoutObservableArray<place>;
    person_id         : KnockoutObservable<string>;
    place_id          : KnockoutObservable<string>;
    place_relationship: KnockoutObservable<string>;

    constructor(item: any){
        super();
        this.person_id          = ko.observable(item.person_id).extend({ maxLength: 32 });
        this.place_id           = ko.observable(item.place_id).extend({ maxLength: 32 });
        this.place_relationship = ko.observable(item.place_relationship).extend({ maxLength: 128 });
        this.place = <KnockoutObservableArray<place>>this.loadRelation(item, place, "place", "single");
    }
}


